import OverlaySidebarCart from '@/pages/OverlaySidebarCart'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: OverlaySidebarCart,
		vueInit: "initializeSidebarCart",
	}

	let page = vuewidget(dom, options)
	return page
}